var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHybrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.1782,
    height: 44.1782,
    rx: 22.0891,
    fill: "#0196B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6683 18.163H26.2899C26.3069 17.9278 26.3069 17.6918 26.2899 17.4567C26.2899 16.3418 25.847 15.2726 25.0587 14.4842C24.2703 13.6958 23.2011 13.2529 22.0862 13.2529C20.9712 13.2529 19.902 13.6958 19.1136 14.4842C18.3253 15.2726 17.8824 16.3418 17.8824 17.4567C16.9767 17.5009 16.1228 17.8918 15.4975 18.5484C14.8722 19.205 14.5234 20.077 14.5234 20.9837C14.5234 21.8904 14.8722 22.7624 15.4975 23.419C16.1228 24.0755 16.9767 24.4664 17.8824 24.5107H26.6683C27.4818 24.4688 28.2482 24.1161 28.8091 23.5255C29.3701 22.9349 29.6829 22.1514 29.6829 21.3368C29.6829 20.5222 29.3701 19.7387 28.8091 19.1481C28.2482 18.5575 27.4818 18.2048 26.6683 18.163Z",
    stroke: "white",
    strokeWidth: 1.61425,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 27.7305H18.8672",
    stroke: "white",
    strokeWidth: 1.61425,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2484 27.7305H12.4141",
    stroke: "white",
    strokeWidth: 1.61425,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7509 30.9507H26.1094",
    stroke: "white",
    strokeWidth: 1.61425,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5046 30.9507H14.8359",
    stroke: "white",
    strokeWidth: 1.61425,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybrid);
export default __webpack_public_path__ + "static/media/hybrid.b35ee2db22eaaf208f674665d0d78f3b.svg";
export { ForwardRef as ReactComponent };